<template>
  <div>
    <div class="contentTitle row hidden-head">
      <p>占いに使用するプロフィール</p>
    </div>
    <app-loading
      style="margin: 20px auto;"
      :is-loading="true"
      v-show="!((Object.keys(registedColumn).length > 0 && isLoggedIn) || !isLoggedIn)"
    ></app-loading>

    <div
      class="u-mg-t-3"
      v-show="(Object.keys(registedColumn).length > 0 && isLoggedIn) || !isLoggedIn"
    >
      <!-- 入力済み項目表示 -->
      <div class="entryForm" v-if="!isEditMode && Object.keys(registedColumn).length > 0">
        <div class="formGroup" v-for="(value, key) in registedColumn" :key="key" :data-name="key">
          <form-label :label="FORM_LABELS[key]" class="sub"></form-label>
          <span class="u-tx-primary">{{ paramToString(key, value) }}</span>
        </div>
      </div>

      <hr class="contentSeparator" v-show="!isEditMode && showFieldSection(self)">

      <form :action="action" :method="method" @submit.prevent="handleSubmit()" ref="entryForm">
        <input type="hidden" name="_token" :value="csrfToken">
        <input type="hidden" name="items_id" :value="itemsId">
        <input type="hidden" v-if="cpno" name="cpno" :value="cpno">
        <input type="hidden" v-if="categoryId" name="category_id" :value="categoryId">
        <input type="hidden" v-if="itemScheduleId" name="item_schedule_id" :value="itemScheduleId">
        <input type="hidden" v-if="guestId" name="guestId" :value="guestId">
        <input type="hidden" name="entry_detail_required" :value="entryDetailRequired">
        <input type="hidden" v-if="orderGenre" name="order_genre" :value="orderGenre">

        <section class="entryForm" v-if="itemsId == '000801'">
          <div class="entryForm">
            <label class="formLabel">
              <span class="labelBadge--required">必須</span>鑑定を希望する占い師名
            </label>
            <form-select v-model="selectCounselor" name="free_text" :options="counselors"></form-select>
            <p class="formGroup__subText">※応募状況によっては希望された占い師以外のビデオレターが当選する場合もございます。予めご了承ください。</p>
          </div>
          <hr class="contentSeparator">
        </section>

        <!-- 自分プロフィール -->
        <section class="entryForm" v-show="showFieldSection(self) && inputEntryType !== 5 && inputEntryType !== 6">
          <div
            v-for="(field, key) in self"
            :key="key"
            v-show="!registedColumn[key] || isEditMode"
            class="u-mg-b-3"
          >
            <entry-form-input
              v-if="key !== 'nonmember_email'"
              v-model="self[key].value"
              :disabled-flg= "disabledFlg"
              :name="key"
              :field="field"
              :is-edit-mode="isEditMode"
            ></entry-form-input>
          </div>
        </section>

        <!-- 手相 -->
        <section class="entryForm" v-show="showFieldSection(palm)">
          <div v-for="(field, key) in palm" :key="key" class="u-mg-b-3">
            <entry-form-input
              v-model="palm[key].value"
              :name="key"
              :field="field"
              :is-edit-mode="isEditMode"
            ></entry-form-input>
          </div>
        </section>

        <!-- 相手プロフィール -->
        <section class="entryForm" v-show="showFieldSection(target)">
          <div
            v-for="(field, key) in target"
            :key="key"
            v-show="!registedColumn[key] || isEditMode"
            class="u-mg-b-3"
          >
            <entry-form-input
              v-model="target[key].value"
              :name="key"
              :field="field"
              :is-edit-mode="isEditMode"
            ></entry-form-input>
          </div>
        </section>

        <!-- 相談内容 -->
        <section class="entryForm" v-if="!isRandSelect" v-show="showFieldSection(entry)">
          <div class="u-mg-b-3" v-if="categoryId == 6 && !isUragei && inputEntryType !== 5 && inputEntryType !== 6 && inputEntryType !== 7">
            <form-label label="テーマ"></form-label>
            <p class="u-mg-t-0">
              <strong class="u-tx-brand">{{orderGenre}}</strong>
            </p>
          </div>
          <div v-for="(field, key) in entry" :key="key" class="u-mg-b-3">
            <entry-form-input
              v-model="entry[key].value"
              :name="key"
              :field="field"
              :is-edit-mode="isEditMode"
              :entry-detail-required="entryDetailRequired"
              @input="handleChangeEntryInput(key, field)"

              <template v-if="!isRandSelect" slot="aside" v-html="field.subtext"></template>
              <template v-else slot="aside" v-html="expText"></template>
            </entry-form-input>
          </div>
        </section>


        <!-- 非会員購入時のemail(nonmember_email) -->
        <section class="entryForm" v-show="showFieldSection(self) && inputEntryType !== 5 && inputEntryType !== 6">
          <div
            v-for="(field, key) in self"
            :key="key"
            v-show="!registedColumn[key] || isEditMode"
            class="u-mg-b-3"
          >
            <entry-form-input
              v-if="key === 'nonmember_email'"
              v-model="self[key].value"
              :disabled-flg= "disabledFlg"
              :name="key"
              :field="field"
              :is-edit-mode="isEditMode"
            ></entry-form-input>
          </div>
        </section>

        <section class="enteyForm" v-if="isLoggedIn">
          <div v-for="(field, key) in auth" :key="key">
            <input type="hidden" :value="auth[key].value" :name="key">
          </div>
        </section>


        <section class="entryFormFooter">
          <button class="btn" data-block="true" data-color="brand">入力した内容を確認</button>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import * as type from '@/utvStore/store/mutation-types';
import EntryFormInput from './EntryFormInput';
import dataControl from './mixins/dataControl';
import viewControl from './mixins/viewControl';
import formControl from './mixins/formControl';
import fetchAccountData from '@/utils/fetchAccountData';
import convertUserInfo from '@/utils/convertUserInfo';

export default {
  name: 'non-member-entry-form',
  props: {
    isRandSelect: Boolean,
    expText: String,
    isUragei: {
      type: Number,
      default: 0
    },
    isTextContents: {
      type: Boolean,
      default: false
    },
    isNonMember: {
      type: Boolean,
      default: false
    }
  },
  mixins: [dataControl, viewControl, formControl],
  components: {
    EntryFormInput
  },

  beforeMount() {
    this.initializeInputData();
  },

  mounted() {
    this.deleteUnuseColumn();
    this.setEntryQuestions(this.categoryId, this.inputEntryType, this.isUragei);
  },

  data: () => ({
    tab: {
      selected: 'registedView',
      collection: [
        {
          name: 'registedView',
          text: '登録済みプロフィール'
        },
        {
          name: 'editView',
          text: '編集する'
        }
      ]
    },
    selectCounselor: '',
    counselors: [
      { text: '希望なし', value: '希望なし' },
      { text: 'Hoshi (not for sale.)', value: 'Hoshi (not for sale.)' },
      { text: '生田目浩美.', value: '生田目浩美.' },
      { text: '青沼李果', value: '青沼李果' },
      { text: '巫弥子', value: '巫弥子' },
      { text: '海龍', value: '海龍' },
      { text: '阿雅佐', value: '阿雅佐' },
      { text: '安沙蘭', value: '安沙蘭' },
      { text: 'ミルン', value: 'ミルン' },
      { text: '法演', value: '法演' },
      { text: 'カフナ・ハウ・ユカ', value: 'カフナ・ハウ・ユカ' },
      { text: 'R.I.O.N', value: 'R.I.O.N' },
      { text: '藤元麻理', value: '藤元麻理' }
    ],
    isEditMode: true,
    disabledFlg: true
  }),

  methods: {
    updateProfile() {
      // 未ログイン(非会員状態)の場合は何もしない
      if (!this.accessToken) {
        return Promise.resolve();
      }
      let data = {};
      const formData = $(this.$refs.entryForm).serializeArray();
      formData.forEach(item => {
        Object.assign(data, {
          [item.name]: item.value
        });
      });
      data = convertUserInfo(data);
      Object.assign(data, {
        access_token: this.accessToken
      });
      return fetchAccountData.updateProfile(data);
    },

    updateAction() {
      // ログイン済みかつテキストの場合はorder/checkを省略する
      return new Promise(resolve => {
        // ToDo::フェーズ２までコメントアウトで動かして要らなかったら消す
        //        if (this.action === '/contents/order/check' && this.isLoggedIn) {
        //          this.$refs.entryForm.action = '/contents/order/complete'
        //        }
        resolve();
      });
    },

    /**
     * Submit処理
     */
    handleSubmit() {
      this.validateBeforeSubmit()
        .then(this.updateProfile)
        .then(this.updateAction)
        .then(() => {
          this.$refs.entryForm.submit();
        })
        .catch(() => {
          return false;
        });
    }
  }
};
</script>


<style lang="scss" scoped>
.contentTitle {
  &.hidden-head {
    height: 0;
    overflow: hidden;
    border-top: 1px solid #d8d8d8;
    padding: 0;
  }
}
.subTitle {
  position: relative;
  background: #f8f8f8;
  font-size: 12px;
  padding: 7px;

  p {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EntryForm/NonMemberEntryForm.vue